import { render, staticRenderFns } from "./NotesIcon.vue?vue&type=template&id=229e3c32&"
import script from "./NotesIcon.vue?vue&type=script&lang=ts&"
export * from "./NotesIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports